import * as React from 'react';
import { Box, Typography, Button, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import ImageUpload from '../../../components/ImageUpload';
import { useEffect } from 'react';
import { editProjUser } from '../../../services/proj-service';
import CustomDropDown from '../../../components/CustomDropDown';
import { isNotEmpty } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { useQuery } from 'react-query';
import { getFileUrl } from '../../../services/s3-service';
import { getSingleComUserServ } from '../../../services/com-service';
import constants from '../../../utils/Constants';

const userTypeArr = [
  { value: "approver", label: "End User" },
  ...(constants.needRequestor ? [{ value: "requestor", label: "Requestor" }] : []),
  { value: "line_manager", label: "Contract Owner" },
  { value: "focal_point", label: "Contract Focal Point" }];


function EditComEmpPage({ type = "proj" }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = location.state || {};
  const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const [img, setImg] = useState({ fileKey: "", fileUrl: "" });
  const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }

  const { isLoading: isUserLoading, isError: isUserErr, error: userErr, data: userData } = useQuery([QueryKey.comUserProfile, userId],
    () => getSingleComUserServ(userId),
    {
      enabled: isNotEmpty(userId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    })


  const { isLoading: isImgLoading, data: imgUrl } = useQuery([QueryKey.img, userData?.profileImg],
    () => getFileUrl({ fileKey: userData?.profileImg }), {
    enabled: isNotEmpty(userData?.profileImg),
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });


  useEffect(() => {
    setLoadingScreen(isUserLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoading]);


  useEffect(() => {
    setLoadingScreen(isImgLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isImgLoading]);

  useEffect(() => {
    if (!userId)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  useEffect(() => {
    if (userData?.comId)
      setNavComValue({ comId: userData?.comId })
    return () => setNavComValue({ comId: "" }); // Reset when leaving the page
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, userData]);

  useEffect(() => {
    if (!imgUrl)
      return
    setImg({ fileKey: userData?.profileImg, fileUrl: imgUrl })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl]);


  function handleImgRemove() {
    setImg({ fileKey: "", fileUrl: "" })
  };

  function handleOnUpload({ fileKey, fileUrl }) {
    setImg({ fileKey, fileUrl })
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {

      const payload = {
        empId: inputObject.empId,
        fName: inputObject.fName,
        lName: inputObject.lName,
        phoneNo: inputObject.phoneNo,
        profileImg: img.fileKey,
      }
    
      const { message } = await editProjUser(payload, userId, type);
      notify("success", message);
      if (ctxtUser?.userType === constants.admin)
        navigate(`${route.aComUserProfile}/?userId=${userId}`, { replace: true });
      else if (ctxtUser?.userType === constants.focalPoint)
        navigate(`${route.cUserProfile}/?userId=${userId}`, { replace: true });
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    if (!values.fName)
      errors.fName = "Name is required!";

    return errors;
  };



  async function handleCancel() {
    if (ctxtUser?.userType === constants.admin)
      navigate(`${route.aComUserProfile}/?userId=${userId}`, { replace: true });
    else if (ctxtUser?.userType === constants.focalPoint)
      navigate(`${route.cUserProfile}/?userId=${userId}`, { replace: true });
    else
      navigate("/", { replace: true })
  }

  if (isUserErr) {
    customAlert(userErr);
    return <h2>Something went wrong</h2>
  }

  return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
    <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
      <Stack width={"20%"}>
        <BackButton />
      </Stack>
      <Stack width={"60%"} alignItems={"center"}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Edit Employee </Typography>
      </Stack>
      <Stack width={"20%"} />
    </Stack>
    <BgBoxOld height={"93%"} py={1}>
      {userData && <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="fName" defaultValue={userData?.fName} errMsg={formErrors.fName} title="First Name *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="lName" defaultValue={userData?.lName} title="Last Name" {...txtFieldSx} />
          <LabelTxtFieldInfo readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} name="username" defaultValue={userData?.username} errMsg={formErrors.username} title="Email ID (Username)" {...txtFieldSx} />
          <LabelTxtFieldInfo name="phoneNo" defaultValue={userData?.phoneNo} title="Contact No" {...txtFieldSx} />
        </Stack>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="empId" defaultValue={userData?.empId} title="Employee ID" {...txtFieldSx} />
          <CustomDropDown readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} name="userType" defaultValue={userData?.userType} errMsg={formErrors.userType} title={"Employee Role"} {...txtFieldSx} ddArr={userTypeArr} />
        </Stack>
        <ImageUpload currentImage={img?.fileUrl} onUpload={handleOnUpload} onRemove={handleImgRemove} boxTitle={"Employee Profile"} btnName={"Upload Image"} />
        <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
          <Button variant="outlined" onClick={handleCancel} sx={{
            fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
            color: theme.palette.custom.btn, mr: 2,
          }}>CANCEL</Button>
          <Button variant="contained" type="submit"
            sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>SAVE</Button>
        </Box>
      </Stack>}
    </BgBoxOld>
  </form>
  );
}

export default EditComEmpPage;